// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import {
  Card,
  Table,
  Row,
  Col,
  Input,
} from 'antd';
import { useLocation } from 'react-router-dom';

import Loading from 'components/Loading';
import formatNumber from 'utils/formatNumber';
import 'assets/css/reportingPageStyle.css';

import {
  reportingChargeback,
} from 'store/actions';
import moment from 'moment-timezone';

type Props = {
  fetchChargebackReporting: Function,
  reportingChargebacks: Array<Object>,
  loading: boolean,
  test: boolean,
  history: {
    push: Function,
  },
  selectedAccount: Object,
};

const Chargebacks = (props: Props) => {
  const {
    loading,
    fetchChargebackReporting,
    reportingChargebacks,
    test,
    selectedAccount,
  } = props;

  const location = useLocation();
  const currencyType = selectedAccount && selectedAccount.currency;
  const [searchValue, setSearchValue] = useState('');
  const [filterdRecods, setFilterdRecords] = useState([]);

  const debouncedFetchTransactions = debounce(fetchChargebackReporting, 2000, { leading: true });

  const getData = (query) => {
    debouncedFetchTransactions({ query });
  };

  useEffect(() => {
    getData(location.search);
  }, [test, selectedAccount, location]);

  useEffect(() => {
    setFilterdRecords(reportingChargebacks);
    setSearchValue('');
  }, [reportingChargebacks]);

  const tableHeader = (title) => (
    <span
      style={{
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#333333',
      }}
    >
      {title}
    </span>
  );

  const columns = [
    {
      title: tableHeader('CHARGEBACK DATE'),
      dataIndex: 'disputeDate',
      width: '20%',
      align: 'left',
      sorter: false,
      sortDirections: ['ascend', 'descend', 'ascend'],
      defaultSortOrder: 'descend',
      render: (disputeDate) => {
        if (disputeDate && selectedAccount && selectedAccount.timezone) {
          const tzDate = moment
            .utc(disputeDate)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
          return (<span>{tzDate}</span>);
        }
        return (
          <>&#8211;</>
        );
      },
    },
    {
      title: tableHeader('CASE #'),
      dataIndex: 'type',
      width: '10%',
      align: 'left',
      render: (type) => (
        <span style={{ cursor: 'pointer' }}>
          {type || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: tableHeader('DESCRIPTION'),
      dataIndex: 'status',
      width: '20%',
      align: 'left',
      render: (text, record) => (
        <span style={{ cursor: 'pointer' }}>
          {`${record?.paymentSession?.description}` || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: tableHeader('LAST 4'),
      dataIndex: 'brand',
      width: '10%',
      align: 'left',
      render: (text, record) => {
        const barnd = record?.paymentSession?.paymentMethod?.card?.lastFour;
        return (
          <span style={{ cursor: 'pointer' }}>
            {barnd || <>&#8211;</>}
          </span>
        );
      },
    },
    {
      title: tableHeader('BRAND'),
      dataIndex: 'brand',
      width: '10%',
      align: 'left',
      render: (text, record) => {
        const barnd = record?.paymentSession?.paymentMethod?.card?.brand;
        return (
          <span style={{ cursor: 'pointer' }}>
            {barnd || <>&#8211;</>}
          </span>
        );
      },
    },
    {
      title: tableHeader('AMOUNT'),
      dataIndex: 'fee',
      width: '15%',
      align: 'left',
      render: (fee) => {
        const total = (fee / 100).toFixed(2);
        return (
          <span style={{ cursor: 'pointer' }}>
            {`${selectedAccount.currency.prefix} ${formatNumber(total, currencyType)}`}
          </span>
        );
      },
    },
    {
      title: tableHeader('AUTH CODE'),
      dataIndex: 'type',
      width: '15%',
      align: 'left',
      render: (text, record) => (
        <span style={{ cursor: 'pointer' }}>
          {`${record?.payment?.authorizationCode}` || <>&#8211;</>}
        </span>
      ),
    },
  ];

  const handleSearch = (searchText) => {
    setSearchValue(searchText);
    setFilterdRecords(reportingChargebacks.filter((data) => JSON.stringify(data).toLowerCase().indexOf(searchText.toLowerCase()) !== -1));
  };

  if (loading || !selectedAccount) {
    return <Loading />;
  }

  return (
    <Card
      style={{
        padding: '0',
        borderWidth: '0',
      }}
      className="reporting_summary_card"
    >
      <Row
        type="flex"
        justify="space-between"
        // className="my-2 pb-2"
        className="mb-4 reporting_summary_filter_bar"
        align="middle"
        style={{
          backgroundColor: '#fbfbfb',
          borderBottom: '1px solid #e0e0e0',
          minHeight: '40px',
        }}
      >
        <Col>
          <Row type="flex" justify="space-between" align="middle">
            &nbsp;
          </Row>
        </Col>
        <Col
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '10px',
          }}
        >
          <Input.Search
            // className="mr-3 mt-3"
            className="reporting_search_input"
            style={{
              width: 300,
              maxHeight: '35px',
            }}
            value={searchValue}
            placeholder="Search All"
            onChange={(e) => handleSearch((e.target.value))}
          />
        </Col>
      </Row>
      <Table
        columns={columns}
        rowKey={(record) => record.gid}
        dataSource={filterdRecods}
        pagination={false}
        className="mx-4"
      />
    </Card>
  );
};

const mapStateToProps = (state) => ({
  reportingChargebacks: state?.reportingChargeback?.entity?.content,
  loading: state.loading.loading,
  test: state.account.test,
  totalElements: state.reportingFunding.totalElements,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  validator: state.loading.validator,
  preserveFilters: state.filterParams.preserveFilters,
});

const mapDispatchToProps = (dispatch) => ({
  fetchChargebackReporting: param => dispatch(reportingChargeback.fetchChargebackReporting({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(Chargebacks);
